import { Flex, Input } from "antd"
import { useEffect, useState } from "react"
import { spaces } from "../../../utils/styles"

const DEBOUNCE_DELAY = 400

export const AssetNameFilter = ({ value, setValue, width = 300 }) => {
  const [searchTerm, setSearchTerm] = useState("")

  useEffect(() => {
    const handler = setTimeout(() => {
      setValue(searchTerm)
    }, DEBOUNCE_DELAY)

    return () => clearTimeout(handler)
  }, [searchTerm, setValue])

  const onChange = (e) => setSearchTerm(e.target.value)

  return (
    <Flex style={{ gap: spaces.space2, alignItems: "center" }}>
      <b style={{ textWrap: "nowrap" }}>Asset:</b>
      <Input placeholder="Filter by name" onChange={onChange} style={{ width }} />
    </Flex>
  )
}
